export default "__VITE_ASSET__B$RnMDF6__"